






import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class File extends Vue {
}
